export default "__VITE_ASSET__1MuQtmgt__"